import { Container, Grid, Typography } from "@mui/material";
import SalesByFairChart from "./SalesByFairChart";
import MonthlySalesArea from "./MonthlySalesArea";
import AvgTicketCard from "./AvgTicketCard";
import Filters from "./Filters";
import { useState } from "react";

export default function DashboardPage() {
  const [filters, setFilters] = useState({ start_date: "", end_date: "" });

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Filters onChange={setFilters} values={filters} />
        </Grid>
        <Grid item xs={12} md={4}>
          <AvgTicketCard
            start_date={filters.start_date}
            end_date={filters.end_date}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <SalesByFairChart
            start_date={filters.start_date}
            end_date={filters.end_date}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h5">Faturamento mensal desse ano</Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <MonthlySalesArea />
        </Grid>
      </Grid>
    </Container>
  );
}
